<script>
import axios from 'axios'

  export default {
    name: "ToggleDiv",
    
    

    props: {
      msg: String,
    },

    data() {
    return {
      isShow1: true,
      isShow2: true,
      isShow3: true,
      isShow4: true,
      isShow5: true,
      isShow6: true,
      filesrcsN: [
        {
          title: 'noiseCode.jpg',
          src: require('@/assets/noiseCode.jpg'),
        },
        
        
        
      ],
      filesrcsA: [
        
        {
          title: 'analyserCode.jpg',
          src: require('@/assets/codeAnalyser.jpg'),
        },
        
        
        
      ],
      filesrcsS: [
        
        {
          title: 'signalsCode.jpg',
          src: require('@/assets/codeSignals.jpg'),
        },
        
        
      ],
    }
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(url, title) {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
      })
        .then((response) => {
          this.forceFileDownload(response, title)
        })
        .catch(() => console.log('error occured'))
    },
  }
  };
</script>





<template>
    <h1>Audiosignale</h1>

    <div align="center"  v-if="true">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
          <h5 class="card-title">Audiosignale</h5>
          <div align="left" class="card-body">
            Um verschiedene Schallarten grob zu unterscheiden, wird in folgende Kategorien unterteilt:
            <br>
            <br>
            <ul>
              <li> <b>Geräusch</b>  <img scr="@/assets/Geräusch.png"></li>
              unregelmäßiger Verlauf
              <li> <b>Ton</b> </li>
              Strenger Sinus Ton, periodisch, regelmäßiger Verlauf
              <li> <b>Klang</b> </li>
              Aus verschiedenen periodischen Tönen zusammengesetzt, quasi-periodisch
            </ul>

            Diese Unterschiede werden im Folgenden beispielhaft verdeutlicht.
            <br>
            <br>

            <button class="btn btn-secondary mb-3" style="width:100%;" @click="isShow1 = !isShow1" v-if="isShow1">Weiter</button>

            <div align="center" v-if="!isShow1">
              <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                <h5 class="card-title">Geräusche</h5>
                <div class="card-body" align="left">
                  Geräusche zeichnen sich durch einen nicht-periodischen unregelmäßigen Verlauf aus.<br>
                  Beispiele hierfür sind z.B. verschiedene Rauschsignale wie ein weißes oder braunes Rauschen oder das Geräusch eines brechenden Asts:<br>
                  <br>

                  <ul class="nav nav-pills justify-content-center">
                    <li class="active"><a data-toggle="pill" href="#wn"><button class="btn btn-secondary m-3">White Noise</button></a></li>
                    <li><a data-toggle="pill" href="#pn"><button class="btn btn-secondary m-3">Pink Noise</button></a></li>

                    <li><a data-toggle="pill" href="#ast"><button class="btn btn-secondary m-3">Brechender Ast</button></a></li>

                  </ul>

                  <div class="tab-content" align="center">
                    <div id="wn" class="tab-pane fade in active">
                      <h3>White Noise</h3>
                      
                      <audio controls="true">
                      <source src="@/assets/Audio/WhiteNoise.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                      
                      <div class="p-3">
                        <img src="@/assets/white_noise.png" style="width:80%;" alt="frequency plot sawwave">
                      </div>

                    </div>
                    <div id="pn" class="tab-pane fade">
                      <h3>Pink Noise</h3>
                      Pink Noise wird auch als 1/f-Noise bezeichnet, da die Amplitude mit 1/f zu hohen Freuquenzen abnimmt.
                      <br>
                      <br>
                      <audio controls="true">
                      <source src="@/assets/Audio/PinkNoise.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                      
                      <div class="p-3">
                        <img src="@/assets/Audio/pinkNoisePlot.png" style="width:100%;" alt="frequency plot sawwave">
                      </div>
                    </div>



                    <div id="ast" class="tab-pane fade in active">
                      <h3>Brechender Ast</h3>
                      
                      <audio controls="true">
                      <source src="@/assets/Audio/ast.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                      
                      <div class="p-3">
                        <img src="@/assets/Audio/astplot.png" style="width:80%;" alt="frequency plot sawwave">
                      </div>

                    </div>

                  </div>

                  
                  Wie hier zu sehen ist, lassen sich in den Frequenzspektren der Sounds keine regelmäßigen harmonischen Obertöne, also vielfache des Grundtons, erkennen. Auch im Plot der Signale lassen sich, vor allem bei den Rauschsignalen, keine Regelmäßigkeiten
                  im Verlauf der Signal erkennen. Aufgrund dessen werden diese als Geräusche klassifiziert.
                </div>

                <div align="center">
                <button  type="button" class="btn btn-info m-3 btn-sm" data-toggle="modal" data-target="#ModalNoise" style="width:30%">
                  Python Code um Rauschsignale zu erzeugen
                </button>

                </div>
                

                <!-- Modal -->
                <div class="modal fade" id="ModalNoise" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Python Code - Rauschsignale</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <img src="@/assets/noiseCode.jpg" alt="Python Code Signalerstellung">
                      </div>
                      <div class="modal-footer">

                        <v-flex v-for="(filesrcN, index) in filesrcsN" :key="index" xs12 md4>
                          <v-card @click="downloadWithAxios(filesrcN.src, filesrcN.title)" class="btn btn-secondary m-3" style="width:100%">
                            <v-list>
                              <v-list-item>
                                <v-list-item-icon>
                                  <v-icon class="primary--text"> Download</v-icon>
                                </v-list-item-icon>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-flex>
                        





                        <button type="button" class="btn btn-secondary m-3" data-dismiss="modal">Close</button>

                        
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-secondary mb-3" style="width:100%;" @click="isShow3 = !isShow3" v-if="isShow3">Weiter</button>

              </div>
            </div>

            <div class="card shadow-sm p-3 mb-5 bg-white rounded" align="center" v-if="!isShow3">
              <h5 class="card-title">Töne</h5>
              <div class="card-body" align="left">
                Töne sind die Grundlagen jeden Klangs und stellen die Voraussetzungen für jegliche Harmonien in der Musik dar. <br>
                Sie lassen sich mathematisch am Besten durch einfache Sinus- und Cosinusfunktionen beschreiben und hören sich wie folgt an: <br>

                  <ul class="nav nav-pills justify-content-center">
                    <li class="active"><a data-toggle="pill" href="#sine440"><button class="btn btn-secondary m-3">Sinus 440Hz</button></a></li>
                    <li><a data-toggle="pill" href="#sine100"><button class="btn btn-secondary m-3">Sinus 100Hz</button></a></li>
                  </ul>
                  
                  
                  <div class="tab-content" align="center">
                    <div id="sine440" class="tab-pane fade in active">
                      <h3>Sinus 440Hz</h3>
                      
                      <audio controls="true">
                      <source src="@/assets/Audio/sin440.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                      
                      <div class="p-3">
                        <img src="@/assets/sinePlot.png" style="width:80%;" alt="frequency plot sawwave">
                      </div>

                    </div>
                    <div id="sine100" class="tab-pane fade">
                      <h3>Sinus 100</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/sin100.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                      
                      <div class="p-3">
                        <img src="@/assets/sinePlot100.png" style="width:80%;" alt="frequency plot sawwave">
                      </div>
                    </div>

                  </div>
                Wie hier zu sehen ist, bestehen Töne im Frequenzbereich nur aus einer Frequenz mit konstanter Phase.
              </div>
              <button class="btn btn-secondary mb-3" style="width:100%;" @click="isShow4 = !isShow4" v-if="isShow4">Weiter</button>

            </div>

            <div class="card shadow-sm p-3 mb-5 bg-white rounded" v-if="!isShow4" align="center">
                <h5 class="card-title">Klänge</h5>
                <div class="card-body" align="left">
                  Klänge setzen sich generell aus Tönen zusammen, können jedoch auch Anteile von Geräuschen beinhalten.
                  <br>
                  Durch das Kombinieren mehrerer periodischen Schwingungen, entstehen neue Klänge mit unterschiedlichen Obertönen, die den Charakter der Klänge prägen.
                  <br>
                  <br>
                  In folgendem Beispiel wird eine Sqaure-Wave (Rechtecksignal) aus verschiedenen Sinusfunktionen, welche als Zeiger dargestellt werden, kombiniert.
                  <br>
                  <br>
                  <div align="center" class="m-3">
                    <img  class="p-3" src="@/assets/Audio/FourierSquare.gif" alt="Fourier Square Animation"> <br>
                  </div>
                  
                  <div align="left">

                  Hier stellt jeder Zeiger eine Sinus- oder Cosinusfunktion dar. Bei einer Squarewave werden immer alle geraden Vielfachen des Grundtons aufaddiert, wodurch sich theoretisch bei <br>
                  unbegrenzeter Samplefrequenz eine perfekte Rechteckwelle darstellen lässt.<br>
                  <br>
                  Beispiele für Klänge könnten bspw. der Ton einer aufgenommenen Trompete, die Kombination mehrerer Sinustöne zu einer Rechteckwelle oder auch ein gesprochenes Wort der menschlichen Stimme sein. Bei Letzterem lassen sich im Plot sowohl der tonale Anteil des Vokals 'i', als auch der atonale 'Geräusch'-Teil des 'ch' im oberen Frequenzbereich erkennen.

                  </div>

                  

                  <ul class="nav nav-pills justify-content-center">
                    <li class="active"><a data-toggle="pill" href="#trompete"><button class="btn btn-secondary m-3">Trompete</button></a></li>
                    <li><a data-toggle="pill" href="#vokal"><button class="btn btn-secondary m-3">Wort 'Ich' mit Vokal 'i'</button></a></li>
                    <li><a data-toggle="pill" href="#rechteck"><button class="btn btn-secondary m-3">Rechteckwelle</button></a></li>
                    
                  </ul>


                  <div class="tab-content" align="center">
                    <div id="trompete" class="tab-pane fade in active">
                      <h3>Trompete</h3>
                      
                      <audio controls="true">
                      <source src="@/assets/Audio/trumpet-392Hz.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>

                      <div class="p-3" align="center">
                        <img width="80%" src="@/assets/Audio/trumpetplot.png" alt="trumpetplot">
                      </div>

                    </div>
                    <div id="vokal" class="tab-pane fade" align="center">
                      <h3>Wort 'Ich'</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/ich.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>

                      <div class="p-3" align="center">
                        <img width="80%" src="@/assets/Audio/ichplot.png" alt="ichplot">
                      </div>
                    
                    </div>

                    <div id="rechteck" class="tab-pane fade" align="center">
                      <h3>Rechteckwelle</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/440squarec.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>

                      <div class="p-3" align="center">
                        <img width="80%" src="@/assets/Audio/sawcplot.png" alt="frequency plot sawwave">
                      </div>
                    
                    </div>

                  

                  </div>



                  
                </div>

                <div align="center">
                  <button type="button" class="btn btn-info m-3 btn-sm" data-toggle="modal" data-target="#analysemodal" style="width:30%">
                  Python Code um Audio zu analysieren
                  </button>
                </div>
                

                <!-- Modal -->
                <div class="modal fade" id="analysemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Python Code - Audio Dateien Analysieren</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <img src="@/assets/codeAnalyser.jpg" alt="Python Code Analyser">
                      </div>
                      <div class="modal-footer">
                        <v-flex v-for="(filesrcA, index2) in filesrcsA" :key="index2" xs12 md4>
                          <v-card @click="downloadWithAxios(filesrcA.src, filesrcA.title)" class="btn btn-secondary m-3" style="width:100%">
                            <v-list>
                              <v-list-item>
                                <v-list-item-icon>
                                  <v-icon class="primary--text"> Download</v-icon>
                                </v-list-item-icon>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-flex>



                        <button type="button" class="btn btn-secondary m-3" data-dismiss="modal">Close</button>

                        
                      </div>
                    </div>
                  </div>
                </div>



                <button class="btn btn-secondary mb-3" style="width:100%;" @click="isShow5 = !isShow5" v-if="isShow5">Weiter</button>
              </div>

            <div align="center" v-if="!isShow5">
              <div class="card shadow-sm p-3 mb-5 bg-white rounded">
                <h5 class="card-title">Typische Audiosignale</h5>
                <div class="card-body">
                  Typische Audiosignale mit einer Frequenz von 500 Hz die man viel in der Musikproduktion und Nachrichtenübertragung findet, können Folgende sein:

                  <div align="center" class="m-3">
                    <img width="100%" src="@/assets/deterministic_signals.png" alt="Deterministische Signale">
                  </div>

                  <div align="left">
                  Und mit einer <b> logarithmierten Frequenzachse </b>sehen diese Signale folgendermaßen aus:
                  </div>

                  <div align="center" class="m-3">
                    <img width="100%" src="@/assets/deterministic_signals_log.png" alt="Deterministische Signale">
                  </div>



                





                  <ul class="nav nav-pills justify-content-center">
                    <li class="active"><a data-toggle="pill" href="#sinus"><button class="btn btn-secondary m-3">Sinus</button></a></li>
                    <li><a data-toggle="pill" href="#sägezahn"><button class="btn btn-secondary m-3">Sägezahn</button></a></li>
                    <li><a data-toggle="pill" href="#dreieck"><button class="btn btn-secondary m-3">Dreieck</button></a></li>
                    <li><a data-toggle="pill" href="#test"><button class="btn btn-secondary m-3">Rechteck</button></a></li>
                  </ul>


              





                  <div class="tab-content">
                    <div id="sinus" class="tab-pane fade in active">
                      <h3>Sinus</h3>
                      
                      <audio controls="true">
                      <source src="@/assets/Audio/500HzSinus.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>

                    </div>
                    <div id="sägezahn" class="tab-pane fade">
                      <h3>Sägezahn</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/500HzSawtooth.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                    
                    </div>

                    <div id="dreieck" class="tab-pane fade">
                      <h3>Dreieck</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/500HzTriangle.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>

                    </div>

                    <div id="test" class="tab-pane fade">
                      <h3>Rechteck</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/500HzRectangle.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>

                    </div>

                  </div>

                  


                



              </div>
              </div>
              <div align="center">
                <button  type="button" class="btn btn-info m-3 btn-sm" data-toggle="modal" data-target="#ModalSignals" style="width:30%">
                  Python Code um Signale zu erstellen
                </button>

              </div>
                

                <!-- Modal -->
                <div class="modal fade" id="ModalSignals" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Python Code - Deterministische Signale</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <img src="@/assets/codeSignals.jpg" alt="Python Code Signalerstellung">
                      </div>
                      <div class="modal-footer">
                        <v-flex v-for="(filesrcS, index3) in filesrcsS" :key="index3" xs12 md4>
                          <v-card @click="downloadWithAxios(filesrcS.src, filesrcS.title)" class="btn btn-secondary m-3" style="width:100%">
                            <v-list>
                              <v-list-item>
                                <v-list-item-icon>
                                  <v-icon class="primary--text"> Download</v-icon>
                                </v-list-item-icon>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-flex>


                        <button type="button" class="btn btn-secondary m-3" data-dismiss="modal">Close</button>

                        
                      </div>
                    </div>
                  </div>
                </div>
              <button class="btn btn-primary mb-3" style="width:100%;" @click="isShow6 = !isShow6" v-if="isShow6">Modul abschließen</button>

            </div>  

            



          </div>
        </div>
      </div>
</template>
